import { useCallback } from 'react'

import { useClickaway } from '@/hooks/useClickaway'
import { useReduxDispatch } from '@/store/hooks'
import { modalActions } from '@/store/modal'
import { viewActions } from '@/store/view'

export const ClickawayListener = () => {
  const dispatch = useReduxDispatch()

  const onClickAway = useCallback(() => {
    dispatch(viewActions.collapseSidebars())
    dispatch(modalActions.closeAll())
  }, [dispatch])

  useClickaway({ ignore: 'allScopes', onClickAway })

  return null
}
